const SHARED_API_BASE = '/o/shared-rest-api/v1.0';

export interface TranslationsResponse {
    translations: {key: string; value: string}[];
}

export const fetchTranslations = async (
    languageId: string,
    keys: string[]
): Promise<TranslationsResponse> => {
    console.debug('Try to load translations for', languageId, keys);
    const response = await Liferay.Util.fetch(
        `${SHARED_API_BASE}/translations?locale=${encodeURIComponent(languageId)}`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(keys),
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP Error ${response.status}`);
    }
    return response.json();
};
